module.exports = __webpack_public_path__ + "img/country.51f90c08.png";